import lazyLoading from './lazyLoading'
import Apis from '../../../core/Apis'
// import Apis from '../../../core/Apis'

export default {
    path: '/label',
    component: lazyLoading('contentlabel', true),
    meta: {
        icon: 'fa fa-cog fa-fw menu-icon',
        label: '数据标注',
        expanded: false,
        noRedirect: true
    },
    children: [
        {
            name: 'LabelIndex',
            path: 'index',
            component: lazyLoading('contentlabel/ContentLabel'), // 加载模块
            meta: {
                label: '标注任务',
                hidden: true,
                auth: {
                    needApis: [Apis.bzxt.task.missionList]
                }
            }
        },
        {
            name: 'ErrorList',
            path: 'errorlist',
            component: lazyLoading('contentlabel/ErrorList'), // 加载模块
            meta: {
                label: '内容预标',
                parent: 'LabelIndex',
                nomenu: true
            }
        },
        {
            name: 'Training',
            path: 'training',
            component: lazyLoading('contentlabel/Training'), // 加载模块
            meta: {
                label: '练习',
                parent: 'LabelIndex',
                nomenu: true
            }
        },
        // {
        //     // qc
        //     name: 'Inspecting',
        //     path: 'inspecting',
        //     component: lazyLoading('contentlabel/Inspecting'), // 加载模块
        //     meta: {
        //         label: '练习',
        //         parent: 'LabelIndex',
        //         nomenu: true
        //     }
        // },
        {
            name: 'Tagging',
            path: 'tagging',
            component: lazyLoading('contentlabel/Tagging'), // 加载模块
            meta: {
                label: '标注',
                parent: 'LabelIndex',
                nomenu: true
            }
        },
        {
            name: 'Fault',
            path: 'fault',
            component: lazyLoading('contentlabel/Fault'), // 加载模块
            meta: {
                label: '错误数据列表',
                parent: 'LabelIndex',
                nomenu: true
            }
        },
        {
            name: 'TagRecord',
            path: 'TagRecord',
            component: lazyLoading('contentlabel/TagRecord'), // 标注记录
            meta: {
                label: '标注记录',
                parent: 'LabelIndex',
                nomenu: true
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/contentlabel.js